function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3.175 3.175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.74.533c0-.02-.02-.04-.04-.06-.019-.018-.038-.038-.058-.038-.019-.02-.059-.02-.078-.02H.806C.69.415.611.494.611.611s.078.196.195.196h1.29L.473 2.427a.19.19 0 0 0 0 .274.18.18 0 0 0 .137.059.18.18 0 0 0 .137-.06l1.621-1.62v1.289c0 .117.078.195.195.195s.196-.078.196-.195V.61c0-.02 0-.059-.02-.078",
    style: {
      strokeWidth: 0.19531
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.67817c628c1f5c1a614eee531b4f0cfd.svg";
export { ForwardRef as ReactComponent };